function isMockSession(session: string | null): boolean {
  return session !== null && session.endsWith('.nexus-mock-signature');
}

const OIDC_STORAGE_KEYS = [
  'access_token',
  'access_token_stored_at',
  'expires_at',
  'id_token',
  'id_token_claims_obj',
  'id_token_expires_at',
  'id_token_stored_at',
  'refresh_token',
  'granted_scopes',
  'session_state',
  'nonce',
  'PKCE_verifier',
];

function clearMockOidcTokens(storage: Storage): void {
  if (isMockSession(storage.getItem('access_token'))) {
    OIDC_STORAGE_KEYS.forEach((key) => storage.removeItem(key));
  }
}

function clearMockSession(): void {
  const session = localStorage.getItem('local_session');
  if (isMockSession(session)) {
    localStorage.removeItem('local_session');
    delete (globalThis as any).iamSession;
  }
  clearMockOidcTokens(localStorage);
  clearMockOidcTokens(sessionStorage);
}

function checkMocksEnabled(): boolean {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('mocks')) {
    const enabled = urlParams.get('mocks') === 'true';
    if (enabled) {
      sessionStorage.setItem('mocks', 'true');
    } else {
      sessionStorage.removeItem('mocks');
      clearMockSession();
    }
    return enabled;
  }
  if (sessionStorage.getItem('mocks') === 'true') return true;
  if (localStorage.getItem('mocks') === 'true') return true;
  return (globalThis as any).enableMocks === true;
}

export async function enableMocksIfNeeded(): Promise<void> {
  const mocksEnabled = checkMocksEnabled();

  if (!mocksEnabled) {
    clearMockSession();
    return;
  }

  try {
    const { startMSW } = await import('./browser');
    const started = await startMSW();
    if (started) {
      (globalThis as any).devServer = true;
    } else {
      sessionStorage.removeItem('mocks');
    }
  } catch (err) {
    console.error('[MSW] Failed to start, continuing without mocks:', err);
    sessionStorage.removeItem('mocks');
  }
}
